"use client";

import React from "react";
import { Twitter, Linkedin, Github, ArrowUp, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  const services = [{
    name: "Shield - Call Overflow",
    href: "/SolutionsPage"
  }, {
    name: "Bridge - Smart Routing",
    href: "/SolutionsPage"
  }, {
    name: "Concierge - Reception",
    href: "/SolutionsPage"
  }, {
    name: "Closer - Sales AI",
    href: "/SolutionsPage"
  }];
  const resources = [{
    name: "Engage - Reminders",
    href: "/SolutionsPage"
  }, {
    name: "Connect - Transfers",
    href: "/SolutionsPage"
  }, {
    name: "Advance - Scheduling",
    href: "/SolutionsPage"
  }, {
    name: "Convert - Outreach",
    href: "/SolutionsPage"
  }];
  const company = [{
    name: "Home",
    href: "/HomePage"
  }, {
    name: "Solutions",
    href: "/SolutionsPage"
  }, {
    name: "Technology",
    href: "/TechnologyPage"
  }, {
    name: "Industries",
    href: "/IndustriesPage"
  }];
  const legal = [{
    name: "Privacy Policy",
    href: "#"
  }, {
    name: "Terms of Service",
    href: "#"
  }, {
    name: "Security & Compliance",
    href: "/TechnologyPage"
  }, {
    name: "Contact Us",
    href: "/ContactUsPage"
  }];
  const socialLinks = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Github,
    href: "#",
    label: "GitHub"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  return <footer data-section-id="12814" id="footer" className="dark bg-background text-foreground border-t border-white/10 font-sans">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-16">
          <div className="max-w-md space-y-6">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572085/img/image_lierugz9.png" alt="MollyCall.ai Logo" className="h-8 w-auto object-contain" />
            </Link>
            <p className="text-base text-muted-foreground leading-relaxed font-light">
              MollyCall.ai is an enterprise-grade AI voice automation platform that handles inbound and outbound business calls with intelligent voice agents. We empower businesses to never miss a lead and automate repetitive phone tasks through high-fidelity conversational AI.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {}
          <div className="space-y-4">
            <h3 className="text-sm font-bold tracking-widest uppercase text-foreground">Inbound AI</h3>
            <ul className="space-y-3">
              {services.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-base text-muted-foreground hover:text-primary transition-colors font-normal">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="text-sm font-bold tracking-widest uppercase text-foreground">Outbound AI</h3>
            <ul className="space-y-3">
              {resources.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-base text-muted-foreground hover:text-primary transition-colors font-normal">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="text-sm font-bold tracking-widest uppercase text-foreground">Platform</h3>
            <ul className="space-y-3">
              {company.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-base text-muted-foreground hover:text-primary transition-colors font-normal">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="text-sm font-bold tracking-widest uppercase text-foreground">Connect</h3>
            <ul className="space-y-3">
              {legal.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-base text-muted-foreground hover:text-primary transition-colors font-normal">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-sm text-muted-foreground order-2 md:order-1 font-light">
            &copy; {currentYear} MollyCall.ai. Intelligence in every conversation.
          </div>

          <div className="flex items-center gap-4 order-1 md:order-2">
            <div className="flex items-center gap-2">
              {socialLinks.map((social, i) => <Link key={i} to={social.href} className="text-muted-foreground hover:text-primary transition-colors p-2 hover:bg-white/5 rounded-full flex items-center justify-center backdrop-blur-sm" aria-label={social.label} data-index={i}>
                  <social.icon className="size-5" />
                </Link>)}
            </div>
            
            <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-full border-white/10 hover:bg-white/5 hover:text-primary ml-4 bg-transparent transition-all" aria-label="Back to top">
              <ArrowUp className="size-4" />
            </Button>
          </div>
        </div>
      </div>
    </footer>;
}